import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton, Paper } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import HabitCard from "../ui/cards/HabitCard";
import { fetchDailyActivityRange } from "../apiservices/ApiService";
import DatePickerRow from "../common/DatePickerRow";


const Card64Activities = ({ card }) => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [currentWeek, setCurrentWeek] = useState(0);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetchDailyActivityRange({ date: selectedDate, dataInDepth: 1 });
        setApiData(response);
        console.error("response :", response);
      } catch (error) {
        console.error("Error fetching activity data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDate]);

  const stepsData = apiData.find((item) => item.date === selectedDate) || {};

  const cards = [
    {
      title: "Steps",
      target: "10,000",
      progress: stepsData.totalSteps ? (stepsData.totalSteps / 10000) * 100 : 0,
      icon: "https://appcdn.goqii.com/storeimg/87816_1734086362.webp",
      color: "#FFA726",
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#f3f3f3",
        padding: 0.1,
        boxSizing: "border-box",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
          backgroundColor: "#f3f3f3",
        }}
      >
        {/* <DatePickerRow
          selectedDate={selectedDate}
          onDateSelect={setSelectedDate}
          currentWeek={currentWeek}
        /> */}

        <DatePickerRow
          selectedDate={selectedDate}
          onDateSelect={setSelectedDate}
          currentWeek={currentWeek}
          setCurrentWeek={setCurrentWeek}
          restrictPastDates={false}  // Restrict past dates for appointment booking
          restrictFutureDates={true} // Allow future dates
        />


        <Box
          sx={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            padding: "10px",
            marginBottom: 0.1,
            backgroundColor: "#f3f3f3",
            borderRadius: 2,
          }}
        >
          {cards.map((card, index) => {
            const actualValue = card.title === "Steps" ? stepsData.totalSteps : null;

            return (
              <HabitCard
                key={index}
                title={card.title}
                target={card.target}
                progress={card.progress}
                icon={card.icon}
                color={card.color}
                actualValue={actualValue}
              />
            );
          })}
        </Box>
      </Paper>
    </Box>
  );
};

export default Card64Activities;